<template>
  <!-- 在线审核人员列表 -->
  <div style="width: 100%;height:100%;padding-right: 20px;">
    <div style="width: 100%;height: 30px;font-size: 16px;font-weight: 600;color: #000000;line-height: 22px;padding-left: 18px;">
      审核人员
    </div>
    <!-- 操作按钮区域 -->
    <a-button @click="handleAssign()" type="primary" icon="usergroup-add" style="margin-bottom:10px;" :disabled="detachDisable">分配审核人员</a-button>
    <!-- <a-button @click="handleAssignMap()" type="primary" icon="table" style="margin-bottom:15px;margin-left:15px;" :disabled="detachDisable">分配任务</a-button> -->
    <!-- table区域-begin -->
    <div class="memberTable">
      <a-table
          ref="table"
          size="middle"
          bordered
          rowKey="id"
          :columns="markerColumns"
          :dataSource="markerData"
          :pagination="markerPagination"
          @change="handleMarkerTableChange"
      >
            <span slot="action" slot-scope="text, record">
               <a-popconfirm title="确定移除吗?" @confirm="() => handleDetach(record)">
                      <a :disabled="detachDisable">移除</a>
               </a-popconfirm>
            </span>
      </a-table>
    </div>
    <!-- table区域-end -->
    <!-- 在线审核人员列表 -->
    <a-modal
        title="分配审核人员"
        :width="800"
        :visible="assignMarkerVisible"
        :confirmLoading="confirmLoading"
        @cancel="handleCloseMarker"
        @ok="handleOk"
        :destroyOnClose="true"
        cancelText="关闭"
        okText="确定"
    >
      <a-col :md="24" :sm="24">
        <a-card :bordered="false" style="height: 60vh">
          <!-- 查询区域 -->
          <div class="table-page-search-wrapper">
            <a-form layout="inline">
              <a-row :gutter="24">
                <a-col :md="9" :sm="9">
                  <a-form-item label="姓名">
                    <a-input placeholder="请输入审核人员姓名" v-model="name"></a-input>
                  </a-form-item>
                </a-col>
                <a-col :md="9" :sm="9">
                  <a-form-item label="账号">
                    <a-input placeholder="请输入审核人员账号" v-model="jl1Account"></a-input>
                  </a-form-item>

                </a-col>
                <a-col :md="6" :sm="6">
                      <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
                        <a-button type="primary" @click="searchQuery" icon="search"></a-button>
                        <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 2px"></a-button>
                      </span>
                </a-col>
              </a-row>
            </a-form>
          </div>
          <!-- table区域-begin -->
          <div>
            <a-table
                ref="table"
                size="middle"
                bordered
                rowKey="userId"
                :columns="userColumns"
                :dataSource="userData"
                :pagination="userPagination"
                :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                @change="handleTableChange"
            >
            </a-table>
          </div>
          <!-- table区域-end -->
        </a-card>
      </a-col>
    </a-modal>
    <!-- 分配任务地图 -->
    <!-- 设置:footer=[]  取消右下角的关闭和确定按钮 -->
    <a-modal
        :title="titleMap"
        :width="1000"
        :visible="assignMarkerMapVisible"
        @cancel="handleCloseMarkerMap"
        @ok="handleOkMap"
        :destroyOnClose="true"
        :footer=[]
        cancelText="关闭">
      <div style="height: 650px">
        <task-assignment-map :markerDataUserResMap='markerDataUserResMap' :baseMapUrl='mapImageUrl' ref="taskAssignmentMap" :mapParams="mapParams"></task-assignment-map>
      </div>
    </a-modal>

  </div>
</template>
<script>
  import {bus} from '@/bus.js'//引入bus.js定义的空的Vue实例
  import pick from 'lodash.pick'
  import moment from "moment"
  import taskAssignmentMap from "@/components/Maps/taskAssignmentMap";
  const markerColumns = [
    {
      title: '序号',
      dataIndex: '',
      key: 'rowIndex',
      align: 'center',
      customRender: function(t, r, index) {
      return parseInt(index) + 1
      }
    },
    {
      title: '用户账户',
      align: 'center',
      dataIndex: 'jl1Account',
    },
    {
      title: '用户姓名',
      dataIndex: 'name',
      align: 'center',
    },
    {
      title: '操作',
      align: 'center',
      dataIndex: 'action',
      scopedSlots: { customRender: 'action' }
    }
  ];
  const userColumns = [
    {
      title: '序号',
      dataIndex: '',
      key: 'rowIndex',
      align: 'center',
      customRender: function(t, r, index) {
        return parseInt(index) + 1
      }
    },
    {
      title: '用户账户',
      align: 'center',
      dataIndex: 'jl1Account',
    },
    {
      title: '用户姓名',
      dataIndex: 'name',
      align: 'center',
    },
  ];
  export default {
    name: "ShenheModal",
    components:{
      taskAssignmentMap
    },
    data (){
      return {
        model: {},
        titleMap:'审核人员-分配任务',
        title:"审核人员列表",
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        form: this.$form.createForm(this),
        markerColumns: markerColumns,
        markerData:[],
        markerDataUser:[],
        /* 分页参数 */
        markerPagination:{
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " 共" + total + "条"
          },
          showQuickJumper: true,
          showSizeChanger: false,
          total: 0
        },
        markerVisible:false,
        taskId:'',
        userColumns: userColumns,
        userData:[],
        /* 分页参数 */
        userPagination:{
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '30'],
          showTotal: (total, range) => {
            return range[0] + "-" + range[1] + " 共" + total + "条"
          },
          showQuickJumper: true,
          showSizeChanger: false,
          total: 0
        },
        assignMarkerVisible:false,
        selectedRowKeys: [],
        selectionRows: [],
        taskStatus:'',
        detachDisable:false,
        assignMarkerMapVisible:false,  //分配任务地图
        mapImageUrl:'',
        mapParams:{
    projection:'EPSG:3857', //注意：必须加上此投影才能显示地图，目前有效的是4326和3857，而4490暂未生效
    center:[108.29883, 35.72902], //地图初始化时的中心坐标【基于4326坐标系
    minZoom:3, //可以缩小的最小级别；若此处未定义，地图接收到undefined则表示不受限制
    maxZoom:22, //可以放大的最大级别；若此处未定义，地图接收到undefined则表示不受限制
    zoom:4, //地图初始化时显示级别；注意：若此处未定义，地图初始化显示不出来
  },
        colorObj:[
            {name:'纯红',value:'rgba(255,0,0,0.2)'},
            {name:'纯蓝',value:'rgba(0,0,255,0.2)'},
            {name:'纯黑',value:'rgba(0,0,0,0.2)'},
            {name:'纯绿',value:'rgba(0,128,0,0.2)'},

            {name:'深天蓝',value:'rgba(0,191,255,0.2)'},
            {name:'深粉色',value:'rgba(255,20,147,0.2)'},
            {name:'紫色',value:'rgba(128,0,128,0.2)'},
            {name:'靛青',value:'rgba(75,0,130,0.2)'},

            {name:'深橙色',value:'rgba(255,140,0,0.2)'},
            {name:'青色',value:'rgba(0,255,255,0.2)'},
            {name:'淡绿色',value:'rgba(144,238,144,0.2)'},
            {name:'浅海洋绿',value:'rgba(32,178,170,0.2)'},

            {name:'灰色',value:'rgba(128,128,128,0.2)'},
            {name:'道奇蓝',value:'rgba(30,144,255,0.2)'},
            {name:'橙红色',value:'rgba(255,69,0,0.2)'},
            {name:'玫瑰棕色',value:'rgba(188,143,143,0.2)'},

            {name:'适中的蓝色',value:'rgba(0,0,205,0.2)'},
            {name:'淡钢蓝',value:'rgba(176,196,222,0.2)'},
            {name:'李子',value:'rgba(221,160,221,0.2)'},
            {name:'深岩暗蓝灰色',value:'rgba(72,61,139,0.2)'},

            {name:'纯白',value:'rgba(255,255,255,0.2)'},
            {name:'纯黄',value:'rgba(255,255,0,0.2)'},
            {name:'纯黄',value:'rgba(255,255,0,0.2)'},
            {name:'草坪绿',value:'rgba(124,252,0,0.2)'},
            
            {name:'纯红',value:'rgba(255,0,0,0.2)'},
            {name:'纯蓝',value:'rgba(0,0,255,0.2)'},
            {name:'纯黑',value:'rgba(0,0,0,0.2)'},
            {name:'纯绿',value:'rgba(0,128,0,0.2)'},

            {name:'深天蓝',value:'rgba(0,191,255,0.2)'},
            {name:'深粉色',value:'rgba(255,20,147,0.2)'},
            {name:'紫色',value:'rgba(128,0,128,0.2)'},
            {name:'靛青',value:'rgba(75,0,130,0.2)'},

            {name:'深橙色',value:'rgba(255,140,0,0.2)'},
            {name:'青色',value:'rgba(0,255,255,0.2)'},
            {name:'淡绿色',value:'rgba(144,238,144,0.2)'},
            {name:'浅海洋绿',value:'rgba(32,178,170,0.2)'},

            {name:'灰色',value:'rgba(128,128,128,0.2)'},
            {name:'道奇蓝',value:'rgba(30,144,255,0.2)'},
            {name:'橙红色',value:'rgba(255,69,0,0.2)'},
            {name:'玫瑰棕色',value:'rgba(188,143,143,0.2)'},

            {name:'适中的蓝色',value:'rgba(0,0,205,0.2)'},
            {name:'淡钢蓝',value:'rgba(176,196,222,0.2)'},
            {name:'李子',value:'rgba(221,160,221,0.2)'},
            {name:'深岩暗蓝灰色',value:'rgba(72,61,139,0.2)'},
        ],
        url: {
          getMarkUserByTaskId:'/task/task/queryMarkUserByTaskId',
          addMarkUserByTaskId:'/task/task/addMarkUserByTaskId',
          deleteMarker:'/task/task/deleteMarkerByTaskId',
          getMarkTaskUser:'/task/task/queryMarkTaskUserById',
          assignMarkerTask:'/task/task/assignMarkerTask',
          getAssignMarkerTask:'/task/task/queryAssignMarkerTask',
        },
        name:'',
        jl1Account:'',
        markerDataUserResMap:[],
        groupId:'d920c681450649a1b6a261f5a7c3af37',
      }
    },
    methods:{
      show(id,taskStatus,imageUrl,groupId){
        if(groupId){
          this.groupId=groupId

        }
        this.taskId = id;
        this.taskStatus = taskStatus;
        if(this.taskStatus === '503'){
            this.detachDisable = true;
        }
        else{
          this.detachDisable = false;
        }
        this.loadMarker(id);
        this.markerVisible = true;
        if(imageUrl.length>0){
            this.mapImageUrl = imageUrl[0].imageUrl;
          }
      },
      //加载当前标注任务选择的审核人员
      loadMarker(){
        let that = this;
        this.axios({
                        method: 'get',
                        url: '/tiles_back/markTask/queryMarkTaskAuditorById',
                        headers: {
                          Authorization: "Bearer " + this.getKey(),
                        },
                        params: {
                          taskId:this.taskId,
                          pageNo:this.markerPagination.current,
                          pageSize:10,
                        }
                    }).then((res) => {
                      this.markerData = [];
                      if(res.data.data.records.length > 0){
                        for (let i = 0; i < res.data.data.records.length; i++){
                          let temp = res.data.data.records[i];
                          this.markerData.push(temp);
                        }
                        this.markerDataUser = this.markerData;
                        for(let j= 0;j<this.markerDataUser.length;j++){
                          this.markerDataUser[j].colorName = this.colorObj[j].name;
                          this.markerDataUser[j].colorValue = this.colorObj[j].value;
                        }
                        this.markerPagination.total = res.data.data.records.length;
                      }
            })
      },
      handleCancel () {
        this.markerVisible = false;
        this.assignMarkerVisible = false;
      },
      handleCloseMarker(){
        this.assignMarkerVisible = false;
      },
      onSelectChange(selectedRowKeys, selectionRows) {
        this.selectedRowKeys = selectedRowKeys;
        this.selectionRows = selectionRows;
      },
      //点击分配审核人员按钮
      handleAssign(){
        this.selectedRowKeys= [];
        this.selectionRows= [];
        this.loadMarkUserList();
        this.assignMarkerVisible = true;
      },
      //加载审核人员列表（不在当前标注任务中的）
      loadMarkUserList(){
        let that = this;
        // this.groupId = 'd920c681450649a1b6a261f5a7c3af37'
        let formData = new FormData();
          // formData.append('taskId', this.taskId);
          formData.append('groupId', this.groupId);
          formData.append('jl1Account', this.jl1Account);
          formData.append('name', this.name);
          formData.append('pageNo', this.userPagination.current);
          formData.append('pageSize', 10);
            this.axios
                .post("/tilesapi/tiles/member/list", formData,{
                  headers: {
                    Authorization: "Bearer " + this.getKey(),
                  },
                }).then((res) => {
                  this.userData = [];
                  if(res.data.data.records.length > 0){
                    for (let i = 0; i < res.data.data.records.length; i++){
                      let temp = res.data.data.records[i];
                      let flag = true;
                      for(let j=0;j<that.markerData.length;j++){
                        if(that.markerData[j].jl1Account === temp.jl1Account){
                          flag = false
                        }
                      }
                      if(flag){
                        that.userData.push(temp);
                      }
                    }
                  }
                  this.userPagination.total = that.userData.length;
                })

      },
      //查询审核人员
      searchQuery(){
        this.loadMarkUserList();
      },
      //重置按钮
      searchReset(){
        this.name = '';
        this.jl1Account = '';
        this.userPagination.current = 1;
        this.loadMarkUserList();
      },
      handleTableChange(pagination, filters, sorter) {
        this.userPagination = pagination;
        this.loadMarkUserList();
      },
      //审核人员列表翻页事件
      handleMarkerTableChange(pagination, filters, sorter){
        this.markerPagination = pagination;
      },
      getKey() {
        return localStorage.getItem("token");
      },
      //选中标注用户
      handleOk(){
        let that = this;
        if(this.selectedRowKeys.length ===  0){
          that.$message.warning("请勾选至少一个审核人员");
        }
        else{
          let userStr="";
          for(let i = 0;i < this.selectedRowKeys.length; i++){
            userStr += this.selectedRowKeys[i] + ","
          }
          let formData = new FormData();
          formData.append('taskId', this.taskId);
          formData.append('userIds', userStr);

            this.axios
                .post("/tiles_back/markTask/addMarkAuditorByTaskId", formData,{
                  headers: {
                    Authorization: "Bearer " + this.getKey(),
                  },
                }).then((response) => {
                  that.assignMarkerVisible = false;
                  that.loadMarker();
                })
        }
      },
      //移除审核人员
      handleDetach(record){
        let that = this;
        console.log(record)
        let formData = new FormData();
          formData.append('taskId', this.taskId);
          formData.append('userIds', record.userId);
        this.axios
                .post("/tiles_back/markTask/deleteMarkAuditorByTaskId", formData,{
                  headers: {
                    Authorization: "Bearer " + this.getKey(),
                  },
                }).then((response) => {
                  that.loadMarker();
                })
        // deleteAction(that.url.deleteMarker, { userId: record.userId, taskId: this.taskId }).then((res) => {
        //   if (res.success) {
        //     this.$message.success('删除成功!');
        //     this.loadMarker();
        //   } else {
        //     that.$message.warning(res.message)
        //   }
        // })
      },
      //点击【分配任务】按钮，地图勾画分配任务
      handleAssignMap(){
        let that = this;
        if(that.markerDataUser.length > 0){
          //加载该标注任务的分配情况
          this.axios({
                        method: 'get',
                        url: '/tiles_back/markTask/queryMarkTaskAuditorById',
                        headers: {
                          Authorization: "Bearer " + this.getKey(),
                        },
                        params: {
                          taskId:this.taskId,
                        }
                    }).then((res) => {
                      
                        if (res.status == 200){
              that.markerDataUserResMap= res.data.data
              //当第一次点击时为空  需要赋值颜色
              let maxTime = 0
              for(let j= 0;j<that.markerDataUserResMap.length;j++){
                if(that.markerDataUserResMap[j].colorName!= null){
                  for(let i=0;i<that.colorObj.length;i++){
                    if(that.markerDataUserResMap[j].colorName == that.colorObj[i].name){
                      maxTime = Math.max(maxTime,i)
                    }
                  }
                }
              }
              for(let j= 0;j<that.markerDataUserResMap.length;j++){
                if(that.markerDataUserResMap[j].colorName== null){
                  that.markerDataUserResMap[j].colorName = that.colorObj[maxTime+j].name;
                  that.markerDataUserResMap[j].colorValue = that.colorObj[maxTime+j].value;
                }
              }
              console.log(that.markerDataUserResMap)
              that.assignMarkerMapVisible = true;
              //前端处理...
            }
                    })

          
          
        }else{
          that.assignMarkerMapVisible = true;
          // that.$message.warning('审核人员不能为空！')
          // return
        }
      },

      //地图勾画分配任务 - 关闭modal
      handleCloseMarkerMap(){
        let that = this;
        that.assignMarkerMapVisible = false
      },
      //地图勾画分配任务 - 确认分配
      handleOkMap(){
        let that = this;
        that.assignMarkerMapVisible = false;
      },
      handleMarkerFromMap(value,markerDataUserMap){
        let that = this;
        that.assignMarkerMapVisible = false;
        if(value){
          if(markerDataUserMap.length>0){
            for(let i=0;i<that.markerDataUser.length;i++){
              for(let j=0;j<markerDataUserMap.length;j++){
                if(that.markerDataUser[i].name === markerDataUserMap[j].realname){
                  that.markerDataUser[i].taskAreaId = markerDataUserMap[j].taskAreaId;
                  that.markerDataUser[i].tifExtent = markerDataUserMap[j].tifExtent;
                  that.markerDataUser[i].inputHang = markerDataUserMap[j].inputHang;
                  that.markerDataUser[i].inputLie = markerDataUserMap[j].inputLie;
                }
              }
            }
            //在这里调用后台方法传递数据
            for(let i = 0; i < that.markerDataUser.length; i++){
              that.markerDataUser[i].taskAreaId = that.markerDataUser[i].taskAreaId.join(";");
            }

            let params = {};
            params.markerDataUser = that.markerDataUser;
            params.taskId = that.taskId;
            this.axios
                .post("/tiles_back/markTask/assignMarkerTask", params,{
                  headers: {
                    Authorization: "Bearer " + this.getKey(),
                  },
                }).then((res) => {
                    if (res.status == 200) {
                      this.$message.success("操作成功");
                    } else {
                      this.$message.warning('操作失败')
                    }
                })
          }
        }
      }
    },
    mounted(){

    },
  }
</script>

<style lang="less" scoped>
.memberTable{
  width: 100%;
  height: 218px;
  overflow-y: scroll
}
/*滚动条样式*/
.memberTable::-webkit-scrollbar {
  width: 4px;
}

.memberTable::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

.memberTable::-webkit-scrollbar-track {
}
</style>